// Generated by CoffeeScript 1.9.1
module.exports.seq = require("./Sequence");
module.exports.seqcol = require("./SeqCollection");
module.exports.feature = require("./Feature");
module.exports.featurecol = require("./FeatureCol");